export const ReleaseTypeExcelHeader = [
  {
    header: "RELEASE TYPE CODE",
    key: "RELEASE TYPE CODE",
  },
  {
    header: "RELEASE TYPE NAME",
    key: "RELEASE TYPE CODE",
  },
  {
    header: "CREATED BY",
    key: "CREATED BY",
  },
  {
    header: "CREATED DATE",
    key: "CREATED DATE",
  },
];

export const ReleaseTypeExcelName = "RELEASE TYPE List";
